<template>
  <v-snackbar
    v-model="notification.show"
    :color="notification.type"
    :timeout="notification.timeout"
    top
    right
    @input="onInput">
    <v-icon left v-if="icon">
      {{ icon }}
    </v-icon>
    {{ notification.message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="hideNotification">
        Kapat
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GlobalNotification',
  computed: {
    ...mapGetters('ui', ['notification']),
    icon() {
      const iconMap = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information',
      };
      return iconMap[this.notification.type] || 'mdi-information';
    },
  },
  methods: {
    ...mapActions('ui', ['hideNotification']),
    onInput(value) {
      if (!value) {
        this.hideNotification();
      }
    },
  },
};
</script>
